import styled from '@emotion/styled';
import { Typography, Button } from '@mgmresorts/mgm-ui';

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.semantic.HeadingMedium2.fontSize}px;
  }
`;
export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledPasswordContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;
export const StyledConfirmPasswordContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;
export const StyledLink = styled(Button)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  padding: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
export const StyledContent = styled.div``;
